import { styled } from '@mui/system'
import { colors } from '../../../../Components/consts'

export const GameInfoOuter = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  '& .left': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    '& .text': {
      fontSize: '0.9rem',
      color: colors.white,
    }
  },
  '& .right': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
  },
}))

export const HeadTitleCon = styled('div')(({ theme }) => ({
  display: 'flex',
  textAlign: 'center',
  '& p': {
    fontSize: '2rem',
    fontWeight: 700,
    color: colors.white,
    margin: '5px 0',
  },
}))

export const TextCon = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  '& .text': {
    fontSize: '0.9rem',
    color: colors.white,
  }
}))

export const BrocastLogoCon = styled('a')(({ theme }) => ({
  minWidth: 60,
  '& > div': {
    '& img': {
      width: 50,
      marginTop: 5,
      marginLeft: 5,
    },
  },
}))
